import { useQuery } from 'react-query';

import config from '../config';

import { useProductGroupApi } from './api';

export default function useVendorProductGroups({
  vendorId = '',
}: {
  vendorId?: string;
}) {
  const api = useProductGroupApi();
  const { data, isFetched, isFetching, isLoading, refetch } = useQuery(
    [config.queryKeys.productGroup, vendorId],
    () => api.list(vendorId),
    {
      enabled: !!vendorId,
    }
  );

  return {
    isFetched,
    isFetching,
    isLoading,
    refetch,
    productGroups: data?.productGroups ?? [],
  };
}
